import { createFileRoute } from "@tanstack/react-router";
import { SpotSettingsPage } from "../../../features/spot/settings";

export const Route = createFileRoute("/_authed/$org/settings/compute")({ component: Page });
function Page() { const { org } = Route.useParams(); return <SpotSettingsPage key={org} org={org} />; }
